import React from "react";
import DateRangeIcon from "@material-ui/icons/DateRange";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { DateRange } from "react-date-range";
import { css, cx } from "emotion";
import ModalBody from "reactstrap/lib/ModalBody";
import Modal from "reactstrap/lib/Modal";
import moment from "moment-timezone";
import * as locales from "react-date-range/dist/locale";

import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
const DateRangePickerFilter = (props) => {
  const { onChange, defaultDate, maxDate, label, iconPosition, ...rest } = props;
  const [open, setOpen] = React.useState(false);
  const [state, setState] = React.useState([
    {
      startDate: new Date(defaultDate.startDate),
      endDate: new Date(defaultDate.endDate),
      key: "selection",
    },
  ]);

  const toggle = (apply) => {
    if (!apply){
      setState([
        {
          startDate: new Date(defaultDate.startDate),
          endDate: new Date(defaultDate.endDate),
          key: "selection",
        },
      ]);
    }
    
    setOpen(!open);
  };

  const handleApply = () => {
    onChange(state[0]);
    toggle(true);
  };

  return (
    <React.Fragment>
      <div {...rest} className="position-relative">
        <div
          onClick={() => toggle()}
          className={cx(
            css`
              height: 40px;
              border-radius: 8px;
            `,
            "cursor-pointer px-2 d-flex justify-content-between align-items-center border-1-secondary"
          )}
        >
          {label && label !== "" && <span className="font-12 mr-2">{label}</span>} 
          {iconPosition !== "right" && <DateRangeIcon />}
          <span className="font-12 font-bold text-center mx-auto">
            {moment(defaultDate.startDate).format("D MMM YYYY")} -{" "}
            {moment(defaultDate.endDate).format("D MMM YYYY")}
          </span>
          {iconPosition && iconPosition === "right" && <DateRangeIcon style={{marginLeft: 10}} />}
        </div>
      </div>
      <Modal
        isOpen={open}
        toggle={toggle}
        centered={true}
        size="md"
        contentClassName={css`
          background: none !important;
          border: none !important;
          .rdrDateDisplayWrapper {
            background: #2196f3 !important;
          }
        `}
      >
        <ModalBody className="d-flex justify-content-center align-items-center">
          <div className="border-1-secondary bg-white p-3">
            {maxDate && (
              <DateRange
                editableDateInputs={false}
                onChange={(item) => setState([item.selection])}
                moveRangeOnFirstSelection={false}
                ranges={state}
                locale={locales["id"]}
                maxDate={maxDate}
              />
            )}

            {!maxDate && (
              <DateRange
                editableDateInputs={false}
                onChange={(item) => setState([item.selection])}
                moveRangeOnFirstSelection={false}
                ranges={state}
                locale={locales["id"]}
              />
            )}
            <button
              className="btn btn-outline-dark btn-block mt-2"
              onClick={() => handleApply()}
            >
              Apply
            </button>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default DateRangePickerFilter;
